import React from "react";

export function validateProfileFields(profile, required) {
  var errors = {},
    hasError = false;
  required.map((key) => {
    var v = profile[key];
    var error = typeof v === "undefined" || v === "" || v === null;

    if (!error && key === "email") {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(v).toLowerCase()) === false) error = true;
    }

    // Assignation de l'erreur à la bonne clé dans le state.
    if (error) hasError = true;
    errors = { ...errors, [key]: error };
  });

  return {
    hasError: hasError,
    errors: errors,
  };
}

export const isChecked = (val) => val === true || val === "true" || val == "1" || val === "t";

export function displayErrorContext(errors) {
  var error = false;
  for (var key in errors) {
    if (errors[key] === true) {
      error = true;
      break;
    }
  }

  if (error)
    return (
      <small className="error-context">
        Certains champs ne sont pas valides. Veuillez corriger les erreurs et retenter la
        soumission.
      </small>
    );
  else return <></>;
}

export const LastProject = {
  get: function () {
    return localStorage.getItem("clb-last-accessed-project-id");
  },
  set: function (id) {
    localStorage.setItem("clb-last-accessed-project-id", id);
  },
};
